var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.77,
    height: 13.77,
    viewBox: "0 0 13.77 13.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add",
    d: "M6.171,4.682l3.45-3.45a.4.4,0,0,0,0-.558L9.063.116a.4.4,0,0,0-.558,0l-3.45,3.45a.263.263,0,0,1-.372,0L1.232.116a.4.4,0,0,0-.558,0L.116.674a.4.4,0,0,0,0,.558l3.45,3.45a.263.263,0,0,1,0,.372L.116,8.5a.4.4,0,0,0,0,.558l.558.558a.4.4,0,0,0,.558,0l3.45-3.45a.263.263,0,0,1,.372,0L8.5,9.621a.4.4,0,0,0,.558,0l.558-.558a.4.4,0,0,0,0-.558l-3.45-3.45a.263.263,0,0,1,0-.372",
    transform: "translate(0 6.885) rotate(-45)",
    fill: "#15326e",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.e759340bf0903de263bf2d1d0881522c.svg";
export { ForwardRef as ReactComponent };